import {
  FLUSH,
  PAUSE,
  PERSIST,
  persistReducer,
  persistStore,
  PURGE,
  REGISTER,
  REHYDRATE,
} from 'redux-persist'
import { ReducersMapObject } from 'redux'
import storage from 'redux-persist/lib/storage'
import { combineReducers, configureStore } from '@reduxjs/toolkit'
import { ConfigureStoreOptions } from '@reduxjs/toolkit/src/configureStore'
import { PersistConfig } from 'redux-persist/es/types'

export function createStore<S>(
  reducers: ReducersMapObject<S, any>,
  { devTools, ...config }: Omit<PersistConfig<S>, 'storage'> & { devTools?: boolean },
) {
  const persistConfig = {
    storage,
    ...config,
  }

  const appReducer = combineReducers({
    ...reducers,
  })

  const rootReducer = (state: S | undefined, action: any) => {
    if (action.type === 'auth/logoutUser') {
      return appReducer(undefined, action)
    }

    return appReducer(state, action)
  }

  const storeConfig: ConfigureStoreOptions = {
    reducer: persistReducer(persistConfig, rootReducer),
    devTools,
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware({
        serializableCheck: {
          ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
        },
      }),
  }

  const store = configureStore(storeConfig)
  const persistor = persistStore(store)

  return { store, persistor }
}
